import Hero from "./components/Hero.jsx";
import Features from "./components/Features.jsx";
import Footer from "./components/Footer.jsx";

export default function App() {
  return (
    <div className="min-h-screen bg-cream-100 selection:bg-brand-500 selection:text-ink">
      <header className="sticky top-0 z-40 backdrop-blur-md bg-cream-100/85 border-b-2 border-ink">
        <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
          <a href="#" className="flex items-center gap-2" aria-label="OK!pag — início">
            <img
              src="/logo.png"
              alt="OK!pag"
              className="h-9 md:h-10 w-auto"
              width="160"
              height="79"
            />
          </a>
          <nav className="flex items-center gap-6 md:gap-8 text-sm font-semibold text-ink">
            <a href="#features" className="hidden sm:inline hover:text-brand-700 transition-colors">
              Recursos
            </a>
            <a href="#contato" className="hidden sm:inline hover:text-brand-700 transition-colors">
              Contato
            </a>
            <a href="#cta" className="btn-primary !py-2 !px-4 text-sm">
              Começar
            </a>
          </nav>
        </div>
      </header>

      <main>
        <Hero />
        <Features />
      </main>

      <Footer />
    </div>
  );
}
